import React from "react"

export const IntlContext = React.createContext()
export const IntlContextProvider = IntlContext.Provider
export const IntlContextConsumer = IntlContext.Consumer